var map = {
	"./piece1.png": 9928,
	"./piece2.png": 5539,
	"./piece3.png": 9978,
	"./piece4.png": 405,
	"./piece5.png": 8140,
	"./piece6.png": 2071,
	"./piece7.png": 2574,
	"./piece8.png": 1961,
	"./piece9.png": 5712
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7402;